import {t} from 'react-multi-lang';

enum IUsability {
    Unrated,
    Rejected,
    Tentative,
    Accepted
}

export function usabilityToString(usability: IUsability): string {
    switch (usability) {
        case IUsability.Unrated:
            return t('global.unrated');
        case IUsability.Tentative:
            return t('global.tentative');
        case IUsability.Accepted:
            return t('global.accepted');
        case IUsability.Rejected:
            return t('global.rejected');
        default:
            return '';
    }
}

export default IUsability;


// WEBPACK FOOTER //
// ./src/interfaces/IUsability.ts